export const setUserTrackingToken = (token: string) => {
  if (typeof window === "undefined") {
    return;
  }

  // codenbutter의 userTrackingToken을 sessionStorage에 저장
  window.sessionStorage.setItem("cbUserTrackingToken", token);
};

export const getUserTrackingToken = () => {
  if (typeof window === "undefined") {
    return null;
  }

  // codenbutter의 userTrackingToken을 sessionStorage에서 가져옴
  return window.sessionStorage.getItem("cbUserTrackingToken");
};

export const initUserTrackingToken = () => {
  const url = new URL(window.location.href);
  const userTrackingToken = url.searchParams.get("cbutt");
  if (userTrackingToken) {
    setUserTrackingToken(userTrackingToken);
  }
};
